<mat-card class="animate__animated animate__fadeIn fadeIn full-height-card">
  <mat-card-content >

  <h1 class="titulo-simpli">nueva cuenta bancaria</h1>
  <small class="subtitulo-simpli">Registra una cuenta bancaria nueva</small>

  <form  [formGroup]="valForm" (submit)="submitForm($event, valForm.value)">

  <div>
      <mat-form-field appearance="fill">
          <input  type="text" placeholder="Banco" panelClass="elleryaqui"   required formControlName="bank" matInput   [matAutocomplete]= "auto" /> 
          <mat-autocomplete #auto = "matAutocomplete" (optionSelected)="filtrar_banco($event.option)">
          <mat-option data-id="{{option.id}}" *ngFor="let option of filteredOptions | async" [value]="option.name">
          {{option.name}}
          </mat-option>
      </mat-autocomplete>
          <mat-hint>Indique el banco</mat-hint>
          <mat-error *ngIf="valForm.controls['bank'].hasError('required') && (valForm.controls['bank'].dirty || valForm.controls['bank'].touched)">
                  El Banco es <strong>requerido</strong>
          </mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill">
          <mat-select placeholder="Tipos de Cuenta" formControlName="type"  required>
              <mat-option *ngFor="let cuenta of cuentas" [value]="cuenta.id">
              {{cuenta.name}}
              </mat-option>
          </mat-select>
          <mat-hint>Indique el tipo de cuenta</mat-hint>
          <mat-error *ngIf="valForm.controls['type'].hasError('required') && (valForm.controls['type'].dirty || valForm.controls['type'].touched)">
              El tipo de cuenta es <strong>requerido</strong>
          </mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill">
          <input matInput placeholder="Nombre y Apellido" formControlName="name"  required>
          <mat-hint>Indique el nombre de la cuenta</mat-hint>
          <mat-error *ngIf="valForm.controls['name'].hasError('required') && (valForm.controls['name'].dirty || valForm.controls['name'].touched)">
              El nombre es <strong>requerido</strong>
          </mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill">
          <input matInput placeholder="Número de cuenta" formControlName="number" type="number"  required>
          <mat-hint>Indique el número de cuenta</mat-hint>
          <mat-error *ngIf="valForm.controls['number'].hasError('required') && (valForm.controls['number'].dirty || valForm.controls['number'].touched)">
              El número de cuenta es <strong>requerido</strong>
          </mat-error>
          <mat-error *ngIf="valForm.get('number')!.hasError('pattern') && (valForm.get('number')!.dirty || valForm.get('number')!.touched)">
              El número de cuenta debe ser numerico y contener de 6 a 12 digitos
          </mat-error>
      </mat-form-field>
  
      <mat-slide-toggle  formControlName="tercero" style="margin-top: 20px; display: flex; font-size: 12px;"> Documento de terceros</mat-slide-toggle>
      

      <mat-form-field appearance="fill">
          <input matInput placeholder="RUT" formControlName="rut" [(ngModel)]="run" (keyup)="change_run()" required>
          <mat-hint>Indique el RUT del número de cuenta</mat-hint>
          <mat-error *ngIf="valForm.controls['rut'].hasError('required') && (valForm.controls['rut'].dirty || valForm.controls['rut'].touched)">
              El RUT es <strong>requerido</strong>
          </mat-error>
          <mat-error *ngIf="valForm.get('rut')!.hasError('pattern') && (valForm.get('rut')!.dirty || valForm.get('rut')!.touched)">
              El RUT debe ser en formato DDDDDDD-D Ejm: 17983599-8
          </mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill">
          <input matInput placeholder="Email" formControlName="email">
          <mat-hint>Indique el correo electronico de la cuenta</mat-hint>
      </mat-form-field>

  </div>


</form>


  </mat-card-content>

  <mat-card-actions align="start">
      <button [disabled]="disabledButton" class="primary-button" color="primary" type="button" (click)="submitForm($event, valForm.value)" mat-raised-button style="margin-top:20px">Guardar</button> 
  </mat-card-actions>
</mat-card>